// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Jngwv","name":"Header_name__2Gwxc","birthday":"Header_birthday__mXCm4","skeleton":"Header_skeleton__Zp_pB"};